import React, { useState } from 'react';
import { db } from './firebase';
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import emailjs from '@emailjs/browser';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';

const ClaseInfo = ({ selectedClass, onClose }) => {
    const [formData, setFormData] = useState({
        madre: '',
        email: '',
        telefono: '',
        bebe: ''
    });
    const [isSuccess, setIsSuccess] = useState(false);
    const [acceptPrivacy, setAcceptPrivacy] = useState(false);
    const [submittedBabyName, setSubmittedBabyName] = useState("");
    const [isBooking, setIsBooking] = useState(false);
    const [legalTab, setLegalTab] = useState('privacy'); // 'privacy' or 'terms'

    const manejarCambio = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const enviarEmail = (datos) => {
        const emailParams = {
            to_name: datos.madre,
            selected_date: `Weekly ${selectedClass.day}s`,
            selected_time: selectedClass.time,
            product_name: "8-Week Journey Subscription",
            location: "Koninginnegracht 101, 2514 AL Den Haag, Netherlands",
            user_email: datos.email,
            baby_name: datos.bebe,
            logo_url: "https://blossom-and-bond-web.web.app/logo.png",
            practical_info: `
                • Please bring a (hydrophilic) cloth or a blanket for your baby to lie/sit on.
                • No shoes in the area (socks are required, no bare feet for adults).
                • Max of 2 adults per baby can be on the mat.
                • Keep a close eye on your little one at all times.
                • Please switch off mobile phones during the entire session.
                • Privacy: Only take photos/videos of your own child. Ask for permission first.
            `
        };

        emailjs.send(
            'service_uyeib46',
            'template_6wqhiwx',
            emailParams,
            'RhdVYv4s0eR91IqKO'
        );
    };

    const procesarReserva = async () => {
        if (!formData.madre || !formData.email || !formData.telefono || !formData.bebe) {
            alert("Please fill in all required fields to proceed.");
            return;
        }

        setIsBooking(true);

        try {
            // Real-time capacity check before final booking (Max 7 families for 8-Week Journey)
            const q = query(
                collection(db, "reservas"),
                where("tipo_registro", "==", "Subscription"),
                where("horario", "==", selectedClass.time),
                where("edad_rango", "==", selectedClass.age),
                where("dia", "==", selectedClass.day)
            );
            
            const snapshot = await getDocs(q);
            const currentBookings = snapshot.size;
            const limit = 7;

            if (currentBookings >= limit) {
                alert("This 8-Week Journey group is now full to ensure a calm and intimate experience for everyone. Please explore our other available times.");
                setIsBooking(false);
                onClose();
                return;
            }

            await addDoc(collection(db, "reservas"), {
                ...formData,
                tipo_registro: "Subscription",
                founding_mother: true,
                horario: selectedClass.time,
                dia: selectedClass.day,
                edad_rango: selectedClass.age,
                fecha_clase: "Weekly",
                fecha_registro: new Date().toLocaleString(),
                created_at: new Date().toISOString(),
                timestamp: Date.now()
            });

            enviarEmail(formData);

            setSubmittedBabyName(formData.bebe);
            setIsSuccess(true);
            setAcceptPrivacy(false);

        } catch (e) {
            console.error(e);
            alert("Error. Please try again.");
        } finally {
            setIsBooking(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ textAlign: 'left', position: 'relative', maxWidth: '550px', borderRadius: '30px' }}>
                <button 
                    onClick={onClose} 
                    style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#666', zIndex: 10 }}
                >
                    ✕
                </button>
                
                {isSuccess ? (
                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                        <h2 style={{ color: 'var(--primary-blue)', marginBottom: '20px', fontFamily: "'Playfair Display', serif" }}>Thank you!</h2>
                        <p style={{ fontSize: '18px', color: 'var(--text-color)', marginBottom: '30px', lineHeight: '1.6' }}>
                            Your 8-Week Journey registration for <strong>{submittedBabyName}</strong> has been received.<br/>
                            Check your email for confirmation and next steps.
                        </p>
                        <button onClick={onClose} className="btn-primary" style={{ width: 'auto', padding: '12px 30px' }}>
                            Close
                        </button>
                    </div>
                ) : (
                    <>
                        <div style={{ marginBottom: '30px', padding: '10px 0' }}>
                            <p style={{ 
                                fontFamily: "'Playfair Display', serif", 
                                fontSize: '20px', 
                                fontStyle: 'italic', 
                                color: 'var(--primary-blue)', 
                                textAlign: 'center',
                                lineHeight: '1.4',
                                marginBottom: '20px'
                            }}>
                                I am really looking forward to welcoming you and your baby to Blossom & Bond. I’ll personally reach out shortly to introduce myself and make sure everything feels comfortable for you.
                            </p>
                            <div style={{ height: '1px', background: 'rgba(0,0,0,0.1)', width: '60%', margin: '0 auto' }}></div>
                        </div>

                        <h2 style={{ textAlign: 'center', marginBottom: '10px', color: 'var(--primary-blue)', fontSize: '24px' }}>
                            8-Week Journey / € 145
                        </h2>
                        <div className="booking-summary" style={{ textAlign: 'center', backgroundColor: '#f9f8f4', padding: '15px', borderRadius: '15px', marginBottom: '25px' }}>
                            <p style={{ margin: 0, fontWeight: 'bold', color: 'var(--primary-blue)' }}>
                                Every {selectedClass.day}
                            </p>
                            <p style={{ margin: '5px 0', color: 'var(--soft-green)', fontSize: '18px' }}>{selectedClass.time} | {selectedClass.age}</p>
                            <p style={{ fontSize: '14px', color: '#888', margin: 0 }}>Boutique Community: Max 7 families</p>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
                            <input name="madre" placeholder="Your Full Name *" value={formData.madre} onChange={manejarCambio} required style={{ marginBottom: '15px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }} />
                            <input name="email" type="email" placeholder="Email Address *" value={formData.email} onChange={manejarCambio} required style={{ marginBottom: '15px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }} />
                            <input name="telefono" type="tel" placeholder="WhatsApp Number *" value={formData.telefono} onChange={manejarCambio} required style={{ marginBottom: '15px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }} />
                            <input name="bebe" placeholder="Baby's Name and Age *" value={formData.bebe} onChange={manejarCambio} required style={{ marginBottom: '15px', padding: '14px', borderRadius: '10px', border: '1px solid #ddd' }} />

                            <div className="legal-tabs">
                                <button 
                                    className={`legal-tab-btn ${legalTab === 'privacy' ? 'active' : ''}`}
                                    onClick={() => setLegalTab('privacy')}
                                >
                                    Privacy Policy
                                </button>
                                <button 
                                    className={`legal-tab-btn ${legalTab === 'terms' ? 'active' : ''}`}
                                    onClick={() => setLegalTab('terms')}
                                >
                                    Terms & Conditions
                                </button>
                            </div>

                            <div className="privacy-policy-scroll-container">
                                {legalTab === 'privacy' ? <PrivacyPolicy /> : <TermsAndConditions />}
                            </div>

                            <div className="privacy-checkbox-container" style={{ margin: '10px 0', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <input 
                                    type="checkbox" 
                                    id="privacyPolicy" 
                                    checked={acceptPrivacy} 
                                    onChange={(e) => setAcceptPrivacy(e.target.checked)} 
                                    style={{ width: '22px', height: '22px', marginTop: '2px' }}
                                />
                                <label htmlFor="privacyPolicy" style={{ fontSize: '14px', color: '#666', lineHeight: '1.4' }}>
                                    I have read and accept the Privacy Policy and Terms & Conditions. I understand that my data will be used to manage this session.
                                </label>
                            </div>

                            <button 
                                onClick={procesarReserva} 
                                disabled={!acceptPrivacy || isBooking} 
                                className="btn-primary" 
                                style={{ 
                                    marginTop: '20px', 
                                    width: '100%', 
                                    padding: '16px', 
                                    fontSize: '18px', 
                                    fontWeight: 'bold',
                                    borderRadius: '15px',
                                    opacity: (!acceptPrivacy || isBooking) ? 0.6 : 1,
                                    cursor: (!acceptPrivacy || isBooking) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isBooking ? "Processing..." : "Join the 8-Week Journey"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ClaseInfo;